module.exports = "<button class=\"btn btn-lg btn-default\" (click)=\"openEditSelectContract($event)\">\n    <i class=\"fi fi-edit\"></i>\n    Edit Contract\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.html
// module id = ./web/modern/components/jobs/modals/edit-contract-button/edit-contract-button.html
// module chunks = 0